import React from 'react';
import ReactDOM from 'react-dom/client'; // Use ReactDOM from react-dom/client for React 18
import App from './App';
// import './i18nConfig';

// Create a root and render the App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

